import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import { HtmlColorBadgeStyle } from "./HtmlColorBadgeStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

export const HtmlStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    return (
        <HtmlColorBadgeStyle
            className={!cellValue || cellValue === "NOT_ACTIVE" ? "aevi-status-badge aevi-inactive" : "aevi-status-badge aevi-active"}
        >
            <sup>{!cellValue || cellValue === "NOT_ACTIVE" ? i18n.t("enum.status.notActive") : i18n.t("enum.status.active")}</sup>
        </HtmlColorBadgeStyle>
    );
};
